export default __webpack_public_path__ + "static/media/Microsoft_Lists_128x128.4d1f994d.webp";